import { chain, each, map, result, isObject, isString, isArray, isEmpty } from 'underscore';
import { cloneDeep } from '@bingads-webui-universal/primitive-utilities';

const buildColumnConversionsMap = columnConversionsMetadata =>
  chain(columnConversionsMetadata)
    .pairs()
    .map(([targetColumnName, { sourceColumnName }]) =>
      (sourceColumnName ? [sourceColumnName, targetColumnName] : null))
    .compact()
    .object()
    .value();

export const getColumnConversions = columnConfigs =>
  chain(columnConfigs)
    .map(({ name: targetColumnName, columnConversion }) =>
      (columnConversion ? [targetColumnName, columnConversion] : null))
    .compact()
    .object()
    .value();

export const buildColumnConversions = (columnConversionsMetadata) => {
  const conversionsMap = buildColumnConversionsMap(columnConversionsMetadata);
  return {
    applyColumnConversions: columnNames =>
      map(columnNames, columnName => result(conversionsMap, columnName, columnName)),
  };
};

export const buildSortingConversions = columnConversionsMetadata => ({
  applySortingInfoConversion: ({
    sortableHeader: savedSortableHeader,
    orderbyInfo: savedOrderbyInfo,
  }) => {
    const res = {
      ...savedSortableHeader ? { sortableHeader: savedSortableHeader } : {},
      ...savedOrderbyInfo ? { orderbyInfo: savedOrderbyInfo } : {},
    };

    if (isObject(savedSortableHeader) &&
      isString(savedSortableHeader.name) &&
      !isEmpty(savedSortableHeader.name)) {
      const sortableConversionInfo = chain(columnConversionsMetadata)
        .pairs()
        .find(([, columnConversion]) =>
          columnConversion.sourceColumnName === savedSortableHeader.name &&
          columnConversion.targetSortableProperty)
        .value();
      if (sortableConversionInfo) {
        const [targetColumnName, { targetSortableProperty, sourceSortableProperty }]
          = sortableConversionInfo;

        res.sortableHeader = {
          ...savedSortableHeader,
          name: targetColumnName,
        };

        if (savedOrderbyInfo && isArray(savedOrderbyInfo)) {
          const orderbyInfo = cloneDeep(savedOrderbyInfo);

          each(orderbyInfo, (orderByItem) => {
            if (orderByItem.key === sourceSortableProperty) {
              // eslint-disable-next-line no-param-reassign
              orderByItem.key = targetSortableProperty;
            }
          });
          res.orderbyInfo = orderbyInfo;
        }
      }
    }

    return res;
  },
});

export const buildColumnAndSortingConversions = columnConversionsMetadata => ({
  ...buildColumnConversions(columnConversionsMetadata),
  ...buildSortingConversions(columnConversionsMetadata),
});
